import { OwnerSelectDropdown } from '@repo/ui';
import DataTypeSpecificInput from 'advanced-filters/components/DataTypeSpecificInput';
import SelectWithSubQuery from 'advanced-filters/components/SelectWithQuery/SelectWithSubQuery';
import { ALL_DATA_TYPES, type DataTypeType } from 'advanced-filters/data/dataTypes';
import {
  type BaseOptionsType,
  FILTERABLE_ENTITY_TYPES,
  type FilterableEntityTypes,
} from 'advanced-filters/data/options';
import { pendingFilterSelector } from 'advanced-filters/selectors/filter';
import { modifyPendingFilter } from 'advanced-filters/store/filter';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function SubConditionValueSelect() {
  const dispatch = useDispatch();
  const {
    conditionKey,
    subConditionKey,
    subConditionComparator,
    subConditionValue,
  } = useSelector(pendingFilterSelector);

  const handleChange = useCallback((value: any) => {
    dispatch(modifyPendingFilter({ subConditionValue: value }));
  }, [dispatch]);

  if (subConditionKey?.dataType === ALL_DATA_TYPES.reference_user) {
    return (
      <OwnerSelectDropdown
        multiple
        forceFetch
        value={subConditionValue?.value?.map((_value: any) => _value?.value)}
        handleClick={(values = []) => handleChange({
          value: (values as string[]).map((value) => ({
            value,
          })),
        })}
      />
    );
  } else if ((
    Object.values(FILTERABLE_ENTITY_TYPES) as unknown as string[]).includes(conditionKey?.entityType || '')) {
    return (
      <SelectWithSubQuery
        context="subCondition"
        value={subConditionValue}
        entity={conditionKey as BaseOptionsType}
        subEntity={subConditionKey}
        handleChange={handleChange}
        comparisionType={subConditionComparator}
      />
    );
  } else {
    return (
      <DataTypeSpecificInput
        entityType={conditionKey?.entityType as FilterableEntityTypes}
        context="subCondition"
        value={subConditionValue}
        inputDataType={subConditionKey?.dataType as DataTypeType}
        comparisionType={subConditionComparator}
        handleChange={handleChange}
      />
    );
  }
}
